import {SupportedLocales} from '#lit/types/locale.js';

export const companyLang = {
  [SupportedLocales.EN]: {
    supportEmail: 'support@growthloop.com',
    website: 'https://www.growthloop.com',
    name: 'GrowthLoop',
  },
  [SupportedLocales.ES]: {
    supportEmail: 'support@growthloop.com',
    website: 'https://www.growthloop.com',
    name: 'GrowthLoop',
  },
};
